import { Subject, debounceTime } from "rxjs"
import { CoordinatorService } from "./coordinator.service"
import { User } from "./user"
import { Timestamp } from "firebase/firestore"
import { Temporal } from "@js-temporal/polyfill"

export type CHANNEL_ACTION = "upload"
type PROJECT_UPDATE = {
    projectId: string,
    action: CHANNEL_ACTION
}
export class CloudChannel {
    private coords: CoordinatorService

    private _queueMap = new Map<string, Map<CHANNEL_ACTION, any[]>>()

    private _projectUpdate$ = new Subject<PROJECT_UPDATE>()

    constructor(private user: User) {
        this.coords = user.coords

        this._projectUpdate$
            .pipe(
                debounceTime(1000)
            ).subscribe(params => this._runProjectQueue(params))
    }


    clear() {
        this._queueMap.clear()
    }

    private async _runProjectQueue(params: PROJECT_UPDATE) {
        const queueLs = this._queueMap
            .get(params.projectId)?.get(params.action)
        if (!queueLs || queueLs.length === 0) return
        await this._emit(params.projectId, params.action, queueLs)
        queueLs.length = 0
    }

    private _queueLs(projectId: string, action: CHANNEL_ACTION) {
        let mp = this._queueMap.get(projectId)
        if (!mp) {
            mp = new Map<CHANNEL_ACTION, any[]>()
            this._queueMap.set(projectId, mp)
        }
        let ls = mp.get(action)
        if (!ls) {
            ls = []
            mp.set(action, ls)
        }
        return ls
    }

    project(projectId: string, action: CHANNEL_ACTION, payload: any) {
        try {
            if (payload?.remotePath?.split("/").pop().startsWith("pin_"))
                return
        } catch (e) {}
        // console.log("CLOUD CHANNEL PROJECT", payload)
        this._queueLs(projectId, action).push(payload)
        this._projectUpdate$.next({
            projectId: projectId,
            action: action
        })
    }

    private async _emit(channelId: string,
        type: string, payload: any) {
        // console.log("CLOUD CHANNEL EMIT", channelId, type, payload)


        await this.coords.firebase$.firestore.addDocument(
            "channel",
            this.coords.uniqueId(), {
            channelId: channelId,
            instanceId: this.coords.instanceId,
            userId: this.coords.user$.currentId,
            timestamp: Temporal.Instant.fromEpochSeconds(
                Timestamp.now().seconds).toString(),
            kind: type,
            payload: payload
        })
    }

    receive(payload: any) {

    }
}
